"use strict";exports.__esModule = true;exports.default = void 0;var _makeupExpander = _interopRequireDefault(require("makeup-expander"));
var scrollKeyPreventer = _interopRequireWildcard(require("makeup-prevent-scroll-keys"));function _getRequireWildcardCache(nodeInterop) {if (typeof WeakMap !== "function") return null;var cacheBabelInterop = new WeakMap();var cacheNodeInterop = new WeakMap();return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {return nodeInterop ? cacheNodeInterop : cacheBabelInterop;})(nodeInterop);}function _interopRequireWildcard(obj, nodeInterop) {if (!nodeInterop && obj && obj.__esModule) {return obj;}if (obj === null || typeof obj !== "object" && typeof obj !== "function") {return { default: obj };}var cache = _getRequireWildcardCache(nodeInterop);if (cache && cache.has(obj)) {return cache.get(obj);}var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {Object.defineProperty(newObj, key, desc);} else {newObj[key] = obj[key];}}}newObj.default = obj;if (cache) {cache.set(obj, newObj);}return newObj;}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var _default =

{
  handleExpand() {
    this.getComponent('options').elementScroll();
    this.emit('expand');
  },

  handleCollapse() {
    this.getEl('button').focus();
    this.emit('collapse');
  },

  handleListboxChange(event) {
    if (this.input.collapseOnSelect) {
      this._expander.expanded = false;
    }
    var selectedIndex = event.index;
    this.state.selectedIndex = selectedIndex;
    this.emit('change', event);
  },

  handleListboxEscape() {
    this._expander.expanded = false;
  },

  onCreate() {
    this.state = {
      selectedIndex: -1
    };
  },

  onInput(input) {
    var { state } = this;
    input.options = input.options || [];
    state.selectedIndex = Math.max(
    -1,
    input.options.findIndex((option) => option.selected));

    input.collapseOnSelect = input.collapseOnSelect !== false;
  },

  onMount() {
    this._setupMakeup();
  },

  onUpdate() {
    this._setupMakeup();
  },

  onRender() {
    if (typeof window !== 'undefined') {
      this._cleanupMakeup();
    }
  },

  onDestroy() {
    this._cleanupMakeup();
  },

  _setupMakeup() {
    var { input } = this;

    if (input.options.length && !input.disabled) {
      var container = this.getEl('container');

      this._expander = new _makeupExpander.default(container, {
        autoCollapse: true,
        expandOnClick: true,
        simulateSpacebarClick: true,
        contentSelector: '.listbox-button__listbox',
        hostSelector: '.listbox-button__control',
        expandedClass: 'listbox-button--expanded',
        focusManagement: 'content'
      });

      scrollKeyPreventer.add(this.getEl('button'));
    }
  },

  _cleanupMakeup() {
    if (this._expander) {
      this._expander.destroy();
      this._expander = undefined;
    }
  }
};exports.default = _default;module.exports = exports.default;